<template>
    <div class="calculator zmv">
        <div class="calculatorBlocks">
            <div class="moneyCalc">
                <div class="label">{{ settings?.local?.zaymovich?.pickSum }}</div>
                <vue-slider
                    v-model="calculatorValue"
                    v-bind="options"
                    @change="(value) => handeDrag(value, '.moneyCalc')"
                    @dragging="(value) => handeDrag(value, '.moneyCalc')"
                />
            </div>
            <div class="termCalc">
                <div class="label">{{ settings?.local?.zaymovich?.pickTerm }}</div>
                <vue-slider
                    v-model="termValue"
                    v-bind="termOptions"
                    @change="(value) => handeDrag(value, '.termCalc', 'minTerm', 'maxTerm')"
                    @dragging="(value) => handeDrag(value, '.termCalc', 'minTerm', 'maxTerm')"
                />
            </div>
        </div>

        <div class="checkboxGroup">
            <div class="checkbox" v-for="(label, key) in settings?.local?.checkbox" :key="key">
                <input type="checkbox" :id="key" :value="label" @change="saveToLocalStorage" v-model="selectedCheckboxes" />
                <label :for="key">{{ label }}</label>
            </div>
        </div>

        <div class="totalGroup">

            <div class="total">
                <div class="yuoGet">
                    <div class="title">{{ settings?.local?.zaymovich?.loan }}:</div>
                    <span>{{ formatValue(total.get, true) }}</span>
                </div>
                <div class="percent">
                    <div class="title">{{ settings?.local?.zaymovich?.commission }}:</div>
                    <span>{{ formatValue(total.rate, false, true) }}%</span>
                </div>
                <div class="toBack">
                    <div class="title">{{ settings?.local?.zaymovich?.toBack }}:</div>
                    <span>{{ formatValue(total.get + total.overpayment, true) }}</span>
                </div>
            </div>

            <div class="buttonHolder">
                <button v-if="settings.local" data-target="target_goal_get_money" :data-href="settings?.url" type="button" class="submit comeback" @click="saveToLocalStorage">
                    {{ settings?.local.zaymovich?.getMoneyButton }}
                </button>
            </div>

        </div>

    </div>
</template>

<script setup>
import  VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import '@/assets/css/form.css';
import {onMounted, ref} from "vue";
import {ajax, setCookie, data, hasClass, getAllCookies, createLabel} from "@/assets/js/Functions";


const props = defineProps({
    element: Object
});

const settings = ref({})
let options = {}
let termOptions = {}

const selectedCheckboxes = ref([])
const calculatorValue = ref(0)
const termValue = ref(0)
const total = ref({
    get: 0,
    return: 0,
    overpayment: 0,
    term: 0,
    rate: 0
})

const calculateTotal = () => {
    total.value.get = calculatorValue.value
    total.value.term = termValue.value
    total.value.return = (((total.value.rate * total.value.term) / 100) * calculatorValue.value) + calculatorValue.value
    total.value.overpayment = total.value.return - total.value.get
}
const formattedSum = () => {
    return (parseInt(calculatorValue.value * rateValue.value)).toLocaleString()
}

const formatValue = (value, addCurrency = true, float = false) => {
    return (float ? value : parseInt(value)).toLocaleString() + (addCurrency && settings?.value?.currency ? ' ' + settings.value.currency : '')
}

const formatValueTerm = (value) => {
    return parseInt(value) +' '+ createLabel(parseInt(value), settings?.value?.local?.zaymovich?.days)
}

const handeDrag = (value, selector, minSelector = 'min', maxSelector = 'max') => {

    const firstLabel = document.querySelector(selector + ' .vue-slider-marks .vue-slider-mark:first-child');
    const lastLabel = document.querySelector(selector + ' .vue-slider-marks .vue-slider-mark:last-child');
    if(firstLabel) firstLabel.style.visibility = (value <= settings.value[minSelector] + 0.15 * (settings.value[maxSelector] - settings.value[minSelector])
        ? 'hidden' : 'visible')

    if(lastLabel) lastLabel.style.visibility = (value >= settings.value[maxSelector] - 0.15 * (settings.value[maxSelector] - settings.value[minSelector])
        ? 'hidden' : 'visible')

    saveToLocalStorage()
    calculateTotal()
}

// Инициализация значений из localStorage при создании компонента
onMounted(() => {
    ajax({
        action: "get_calculator_settings",
        cookies: getAllCookies(),
    }, (response) => {

        settings.value = response

        calculatorValue.value = localStorage.getItem('calculatorValue') ? parseInt(localStorage.getItem('calculatorValue')) : response.from
        termValue.value = localStorage.getItem('termValue') ? parseInt(localStorage.getItem('termValue')) : parseInt((response.maxTerm - response.minTerm) * 0.8) ?? response.minTerm
        total.value.rate = response.minRate ?? 0.01

        options = {
            silent: true,
            dotSize: 30,
            width: 'auto',
            height: 6,
            duration: 0,
            disabled: false,
            marks: [
                response.min,
                response.max
            ],
            min: response.min,
            max: response.max,
            interval: Number.isInteger((response.max - response.min) / response.step) ? response.step : 1,
            enableCross: true,
            hideCoveredLabels: true,
            tooltip: 'always',
            tooltipFormatter: value => formatValue(value, true),
            dotOptions: {
                disabled: false,
                style: {
                    border: '5px solid var(--color-primary)',
                    boxShadow: 'none'
                }
            }
        }

        termOptions = {
            silent: true,
            dotSize: 30,
            width: 'auto',
            height: 6,
            duration: 0,
            disabled: false,
            marks: [
                response.minTerm,
                response.maxTerm
            ],
            min: response.minTerm,
            max: response.maxTerm,
            interval: 1,
            enableCross: true,
            hideCoveredLabels: true,
            tooltip: 'always',
            tooltipFormatter: value => formatValueTerm(value),
            dotOptions: {
                disabled: false,
                style: {
                    border: '5px solid var(--color-primary)',
                    boxShadow: 'none'
                }
            }
        }
        calculateTotal()
    });
});

// Сохранение значений в localStorage при изменении переменных
const saveToLocalStorage = () => {
    setCookie('summ', calculatorValue.value, '365')
    setCookie('term', termValue.value, '365')
    localStorage.setItem('selectedCheckboxes', JSON.stringify(selectedCheckboxes.value));
    localStorage.setItem('calculatorValue', calculatorValue.value);
    localStorage.setItem('termValue', termValue.value)
};
</script>



<style>
.calculator.zmv {
    width: 100%;
    max-width: 1120px;
    border-radius: 19px;
    border-width: 9px;
    border-style: solid;
    border-color: white;
    box-shadow: 0px 2px 5px 0px rgb(0 0 0 / 50%);
    padding: 30px;
    font-family: inherit;
    box-sizing: border-box;
    margin: 10px auto;
}

.calculator.zmv .calculatorBlocks {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    flex-wrap: wrap;
    gap: 40px;
}
.calculator.zmv .calculatorBlocks > div{
    flex: 1 1 0;
}
.calculator.zmv div.label {
    opacity: 0.8;
    font-size: 13px;
    word-wrap: break-word;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    margin-bottom: 26px;
}
.calculator.zmv .vue-slider-dot-tooltip-top {
    top: -4px;
}
.calculator.zmv .vue-slider-dot-tooltip-inner-top::after {
    border-width: 4px;
}
.calculator.zmv .vue-slider-dot-tooltip-inner{
    font-size: 14px;
    line-height: 1;
    text-shadow: none;
    padding: 3px 5px;
    background-color: var(--color-primary);
    border-color: var(--color-primary);
}
.calculator.zmv :not(.mini) .vue-slider-ltr .vue-slider-mark-label, .calculator.zmv :not(.mini) .vue-slider-rtl .vue-slider-mark-label {
    top: -30px;
    margin-top: 0;
    color: #333;
    font-size: 14px;
    line-height: 1;
    padding: 3px 5px;
    background-color: rgba(0,0,0,0.1);
    border-radius: 4px;
    font-weight: 400;
}
.calculator.zmv .checkboxGroup {
    justify-content: flex-start;
    margin: 20px 0;
    gap: 20px;
    padding-bottom: 20px;
    border-bottom: 2px solid #cccccc;
}
.calculator.zmv .totalGroup {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 20px;
}
.calculator.zmv .totalGroup .total {
    flex: 0 0 calc(66% - 10px);
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
}
.calculator.zmv .totalGroup .buttonHolder {
    flex: 0 0 calc(34% - 10px);
}
.calculator.zmv .totalGroup .total > div{
    flex: 1 1 0;
}
.calculator.zmv .totalGroup .total > div div.title{
    font-weight: 400;
    opacity: .8;
    margin-bottom: 6.5px;
    font-size: 13px;
    word-wrap: break-word;
    text-transform: uppercase;
    letter-spacing: .1em;
}
.calculator.zmv .totalGroup .total > div span{
    display: block;
    word-wrap: break-word;
    font-size: 140%;
    font-weight: 500;
}
.calculator.zmv .totalGroup .buttonHolder button{
    margin-bottom: 0;
    background-color: var(--color-primary);
    transition: background-color 300ms ease-in-out;
    border-radius: 25px;
    border: none;
    padding: 10px 20px;
    line-height: 27px;
    font-size: 18px;
}
.calculator.zmv .totalGroup .buttonHolder button:hover {
    background-color: var(--color-primary-hover);
}
@media all and (max-width: 580px){
    .calculator.zmv .calculatorBlocks > div {
        flex: 1 1 100%;
    }
    .calculator.zmv .totalGroup .total > div {
        flex: 1 1 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }
}
@media all and (max-width: 768px){
    .calculator.zmv {
        padding: 10px;
    }
    .calculator.zmv .totalGroup .total {
        flex: 0 0 100%;
        flex-direction: column;
    }
    .calculator.zmv .totalGroup .buttonHolder {
        flex: 0 0 100%;
    }
    .calculator.zmv .totalGroup .total > div span{
        font-size: 18px;
    }
}
</style>